module.exports = __webpack_public_path__ + "img/55.aec8da72.png";